module.exports = __webpack_public_path__ + "img/bf.bc60fc22.svg";